export default "__VITE_ASSET__BwATv$K2__"